export default __webpack_public_path__ + "static/km-iphones-d55139b49ff87e3103f2ea6c85186057.jpg";